'use client';

import { usePathname, useSearchParams } from 'next/navigation';

import { Pagination } from '@gds/Pagination/Pagination';
import { PaginationItem } from '@gds/Pagination/PaginationItem';

import { buildPLPPaginationUrl } from '../../Utils/BuildPLPPaginationUrl';
import type { PaginationProps } from './Pagination.entity';

export const PlpPagination = ({ currentPage, strings, totalPages }: PaginationProps) => {
  const pathname = usePathname();
  const queryParams = useSearchParams();
  const queryParamsString = queryParams.toString();

  return (
    <Pagination
      currentPage={currentPage}
      data-test-id="plp-pagination"
      locale={strings}
      totalPages={totalPages}
      renderItem={paginationItem => (
        <PaginationItem
          component="Link"
          href={buildPLPPaginationUrl(pathname, queryParamsString, paginationItem.page)}
          {...paginationItem}
        />
      )}
    />
  );
};
